import { render, staticRenderFns } from "./FooterToolBar.vue?vue&type=template&id=206495cf&scoped=true&"
import script from "./FooterToolBar.vue?vue&type=script&lang=js&"
export * from "./FooterToolBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206495cf",
  null
  
)

export default component.exports